import React, { SVGProps } from 'react';

const LockIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M11.6961 6.17303V5.19623C11.6961 2.60257 9.59354 0.5 6.99988 0.5C4.40622 0.5 2.30368 2.60257 2.30368 5.1962V6.173C1.06979 6.80268 0.292525 8.07038 0.291016 9.45565V12.8101C0.293248 14.847 1.94395 16.4978 3.98089 16.5H10.0189C12.0558 16.4977 13.7065 14.847 13.7087 12.8101V9.45568C13.7073 8.07041 12.93 6.80268 11.6961 6.17303ZM6.99988 2.51266C8.48195 2.51266 9.68342 3.71413 9.68342 5.1962V5.76578H4.31634V5.1962C4.31634 3.71413 5.5178 2.51266 6.99988 2.51266ZM11.6961 12.8101C11.6961 13.7364 10.9452 14.4873 10.0189 14.4873H3.98092C3.05462 14.4873 2.30371 13.7364 2.30371 12.8101V9.45568C2.30371 8.52939 3.05462 7.77848 3.98092 7.77848H10.0189C10.9452 7.77848 11.6961 8.52939 11.6961 9.45568V12.8101Z"
                fill="#E45858"
            />
            <path
                d="M6.66453 9.79111H7.33541C7.89118 9.79111 8.34174 10.2417 8.34174 10.7974C8.34174 11.3532 7.89118 11.8038 7.33541 11.8038H6.66453C6.10876 11.8038 5.6582 11.3532 5.6582 10.7974C5.6582 10.2417 6.10876 9.79111 6.66453 9.79111Z"
                fill="#E45858"
            />
        </svg>
    );
};

export default LockIcon;
